import { useContext } from "react";
import { AccountContext } from "../contexts/AccountContexts";

export const SplitScreenBackground = () => {
    return (
        <div className="fixed flex w-full min-h-full bottom-0 top-0 origin-bottom -z-10">
            {/* Left side */}
            <div className="w-1/2 bg-gray-100 dark:bg-gray-800"></div>
            <div className="w-1/2 bg-original"></div>
            {/* Right side */}
        </div>
    );
};


export const SplitScreenBackgroundVertical = () => {
    return (
        <div className="fixed flex flex-col w-full min-h-full bottom-0 top-0 origin-bottom -z-10">
            {/* Left side */}
            <div className="h-1/2 bg-original"></div>
            <div className="h-1/2 bg-gray-100 dark:bg-gray-800"></div>
            {/* Right side */}
        </div>
    );
};


export const MemberBackground = () => {
    return (
        <div className="fixed flex flex-col w-full min-h-full bottom-0 top-0 origin-bottom -z-10 bg-gray-100 dark:bg-gray-800 opacity-100"
        >
            <div className="w-full h-full opacity-70"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/bg-1000.png)`, backgroundRepeat: 'repeat', backgroundPosition: '0px -5px', backgroundSize: 'calc(30% - 0px)' }}
            >
            </div>
        </div>
    );
}


export const LoadingScreen = () => {


    return (
        <div
            id="main-loading-screen"
            className="invisible fixed inset-0 bg-black bg-opacity-20 backdrop-blur-[2px] flex items-center justify-center z-50">
            <div className="w-20 h-20 border-t-4 border-b-4 border-primary dark:border-blue-500 rounded-full animate-spin"></div>
        </div>
    )
}


export const PageLoadingScreen = () => {
    const { language } = useContext(AccountContext)

    return (
        <div
            id="page-loading-screen"
            className="invisible absolute inset-0 bg-gray-400 bg-opacity-10 backdrop-blur-[2px] flex items-center justify-center z-[50] transition-all duration-300">
            <div className={`w-20 h-20 border-t-4 border-b-4 border-primary dark:border-blue-500 rounded-full animate-spin flex items-center justify-center 
      ${language === "it" ? "bg-gradient-to-r from-green-600 via-white to-red-600 text-transparent bg-clip-text" : ""} 
      ${language === "fr" ? "bg-gradient-to-r from-blue-600 via-white to-red-600 text-transparent bg-clip-text" : ""}
      
      `}>{language === "it" && "PCQE"}{language === "fr" && "CONVERT"}</div>
        </div>
    )
}


export const ComponentLoadingScreen = ({ tag }) => {


    return (
        <div
            id={"component-loading-screen-" + tag}
            className="invisible absolute inset-0 bg-gray-400 bg-opacity-10 backdrop-blur-[2px] flex items-center justify-center z-[50] transition-all duration-300">
            <div className=" w-20 h-20 border-t-4 border-b-4 border-primary dark:border-blue-500 rounded-full animate-spin"></div>
        </div>
    )
}


export const loadingActive = (isLoading) => {

    if (isLoading) {
        document.getElementById("main-loading-screen").style.visibility = "visible";
    }
    else {
        document.getElementById("main-loading-screen").style.visibility = "hidden";
    }
}


export const pageLoadingActive = (isLoading) => {

    if (isLoading) {
        document.getElementById("page-loading-screen").style.visibility = "visible";
    }
    else {
        document.getElementById("page-loading-screen").style.visibility = "hidden";
    }
}


export const componentLoadingActive = (isLoading, tag) => {
    if (!document.getElementById("component-loading-screen-" + tag)) {
        return
    }
    if (isLoading) {
        document.getElementById("component-loading-screen-" + tag).style.visibility = "visible";
    }
    else {
        document.getElementById("component-loading-screen-" + tag).style.visibility = "hidden";
    }
}